export default __webpack_public_path__ + "static/media/NextProject.76147a75.png";